import React from "react";
import "./typography.css";

interface H2Props {
  text: string;
}
const H2: React.FC<H2Props> = ({ text }) => {
  return <h2 className="H2">{text}</h2>;
};

export default H2;
